<template>
  <div class="template_slide">
    <el-collapse v-model="changeTabsIndex" accordion @change="collapseChange">
      <el-collapse-item class="myel-collapse-item" v-for="(item, indexx) in serve" :key="indexx" :name="indexx"
        :class="item.serve && item.serve.length ==0?'hiddenRight':'' ">
        <template slot="title">
          <div class="prent_item" @click="handleChange(item,indexx)">
            <div class="parent_icon">
              <img
                :src="changeTabsIndex == indexx?'/static/person/'+item.image+'1.png':'/static/person/'+item.image+'2.png'"
                alt="" />
            </div>
            <div class="parent_name" :class="changeTabsIndex == indexx?'actives':''">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </template>
        <div>
          <div v-for="(items, index) in item.serve" :key="index" @click="Mingcheng(indexx, items,index)"
            class="child_item">
            <div class="child_name" :class="{ 'xzcxzcxz': tabid == index }">
              {{ items.title1 }}
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
  export default {
    props:{
      slideItem:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    created() {

      if(!localStorage.getItem('token')){
        this.$router.replace('/')
      }

      this.changeTabsIndex =Number(this.$route.query.id);

      this.$store.dispatch('getUserInfoData',1).then(async (result) => {
        console.log('获取用户信息',result);
        if(result.userInfo.identity == 2){
          this.serve = this.serveList.concat(this.sysemitemList);
        }else{
          this.serve = this.serveList;
        }
      });

      this.tabid = this.$route.query.tab;
    },
    data() {
      return {
        serve:[],
        serveList:[
          {
            title: "我的信息",
            image: 'person',
            path: '/personalc',
            serve: []
          },
          {
            title: '我的关注',
            image: 'guanzhu',
            path: '/wodeguanzhu',
            serve: []
          },
          {
            title: '我的粉丝',
            image: 'fensi',
            path: '/wodefensi',
            serve: []
          },

          {
            title: '历史观看',
            image: 'lishi',
            path: '/lishiguankan',
            serve: []
          },
          {
            title: '我的资产',
            image: 'zichan',
            path: '/wodezichan',
            serve: []
          },
          {
            title: '账户收益',
            image: 'shouyi',
            path: '/yieldmain',
            serve: []
          },
        ],
        sysemitemList: [
        {
          title: '粉丝群',
          image: 'fansgroup',
          path: '/fansGroup',
          serve: []
        },
          {
            title: '推单管理',
            image: 'tuidan',
            path: '/pushorder',
            serve: [{
              title1: "推单",
              path: '/pushorder', // 默认显示第一个
            }, {
              title1: "购买记录",
              path: '/pushorderlog', // 默认显示第一个
            }]
          },
          {
            title: "主播管理",
            image: 'zhuboguanli',
            path: '/shezhiguanliyuan', // 默认显示第一个
            serve: [{
                title1: "设置管理员",
                path: '/shezhiguanliyuan', // 默认显示第一个
              },
              {
                title1: "管理禁言",
                path: '/guanlijinyan', // 默认显示第一个
              },
              {
                title1: "添加直播源",
                path: '/tianjiazhiboyuan', // 默认显示第一个
              },
            ],
          },
          {
            title: "贡献排行榜",
            image: 'shuju',
            path: '/yonghupaihangbang',
            serve: [

            ],
          },
          {
            title: "数据中心",
            image: 'shuju',
            path: '/zhiboshuju',
            serve: [],
          },
        ],
        changeTabsIndex: 0,
        tabid:0
      }
    },
    methods: {
      Mingcheng(e,item, i) {
        this.$emit('change',{
              path: item.path,
              query: {
                id: e,
                tab:i?i:0
              }
          })
      },
      collapseChange(e) {
        console.log(e);
        if (e || e === 0) {
          this.changeTabsIndex = e;
        }
      },
      handleChange(v, i) {
        console.log(v, i);
        // this.changeTabsIndex = i;
        this.$emit('change',{
          path: v.path,
          query: {
            id: i,
            tab: 0
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .personal-bottom-bottom-left .el-collapse-item__header {
    box-sizing: border-box;
    padding-left: 20px;
    background-color: #fff;
    border-bottom: 0px solid #ebeef5;
    color: #333;
  }

  .personal-bottom-bottom-left .is-active {
    color: inherit;
  }

  .personal-bottom-bottom-left .el-collapse-item__content {
    padding-bottom: 0px;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    border-bottom: 1px solid #ebeef5 !important;
  }

  .personal-bottom-bottom-left .el-collapse-item__content>div {
    text-align: center;
  }

  .personal-bottom-bottom-left .el-collapse {
    border-top: 0px solid #ebeef5;
    width: 100%;
  }

  .personal-bottom-bottom-left .el-collapse-item__wrap {
    /* background-color: black; */
    color: #333;
  }
 .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;

    .hiddenRight {
      /deep/ .el-collapse-item__arrow {
        display: none !important;
      }
    }

    .myel-collapse-item {
      width: 190px;
    }

    .prent_item {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      transition: all 1.2s;
      padding: 0 24px;

      .parent_icon {
        display: flex;
        align-items: center;
        margin-right: 4px;
        width: 18px;
        height: 18px;

        img {
          width: 18px;
          height: 18px;
        }
      }

      .actives {
        color: #721edc !important;
        font-size: 15px !important;
      }

      .parent_name {
        display: flex;
        transition: all 0.2s;
        align-items: center;
        font-size: 14px;
      }
    }

    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;

      .child_img {
        display: flex;
        align-items: center;
      }

      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/component/template_slide.vue